import ComplaintsPage from './ComplaintsPage'

const ComplaintsShowPage = () => {
  return <ComplaintsPage />
}

export default ComplaintsShowPage
